import truncate from "lodash/truncate";
import { useState } from "react";
import { useIntl } from "react-intl";

import { contributorsCss, entryCss, noteCss } from "./Entry.styles";

import { ContributorsTextLabel } from "~/client/components/ContributorsTextLabel";
import type { NoteBrowsingHistoryEntry } from "~/client/components/search/hooks/useNoteBrowsingHistory";
import { EntryIcon } from "~/client/components/search/SearchBoxDropdown/EntryIcon";
import { ListItem } from "~/client/components/search/SearchBoxDropdown/ListItem";
import { ListItemLink } from "~/client/components/search/SearchBoxDropdown/ListItemLink";
import { UserAvatarsWithOverflowIcon } from "~/client/components/UserAvatarsWithOverflowIcon";

interface Props {
  entry: NoteBrowsingHistoryEntry;
  isSelected: boolean;
}

const renderContributors = ({ account }) => <span>{account}</span>;
const renderOtherContributors = ({ count }) => <span>{count}</span>;

export const Entry: React.FC<Props> = ({ entry, isSelected }) => {
  const intl = useIntl();
  const [isHover, setIsHover] = useState(false);

  return (
    <ListItem isSelected={isSelected}>
      <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        <ListItemLink to={entry.path}>
          <div css={entryCss}>
            <EntryIcon typename="Note" />
            <div css={noteCss}>
              <span>{isHover ? entry.title : truncate(entry.title, { length: 35 })}</span>
              <div css={contributorsCss}>
                <UserAvatarsWithOverflowIcon users={entry.contributors} size="xsmall" isLink={false} isPopup={false} />
                <ContributorsTextLabel
                  intl={intl}
                  contributors={entry.contributors}
                  renderIndividual={renderContributors}
                  renderOther={renderOtherContributors}
                />
              </div>
            </div>
          </div>
        </ListItemLink>
      </div>
    </ListItem>
  );
};
